import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AllNotifications.css";

const AllNotifications = () => {
  const [activeTab, setActiveTab] = useState("home"); // default tab

  return (
    <section className="AllNotifications-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12 col-md-12 col-sm-12">
            {/* Tabs Nav */}
            <nav>
              <div className="nav nav-tabs nav-fill">
                <button
                  className={`nav-item nav-link ${activeTab === "home" ? "active" : ""}`}
                  onClick={() => setActiveTab("home")}
                >
                  Upcoming Events
                </button>
                <button
                  className={`nav-item nav-link ${activeTab === "cie" ? "active" : ""}`}
                  onClick={() => setActiveTab("cie")}
                >
                  Controller of Examinations (CIE/SEE)
                </button>
                <button
                  className={`nav-item nav-link ${activeTab === "aeb" ? "active" : ""}`}
                  onClick={() => setActiveTab("aeb")}
                >
                  Academic and Examinations (AEB)
                </button>
              </div>
            </nav>

            {/* Tabs Content */}
            <div className="tab-content py-3 px-3 px-sm-0">
              {activeTab === "home" && (
                <div className="tab-pane fade show active">
                  <div className="notification-card">
                    <h2>Upcoming Events</h2>
                    <div className="notification-content">
                      <ul>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <button className="btn btn-info btn-sm">Read More</button>
                  </div>
                </div>
              )}

              {activeTab === "cie" && (
                <div className="tab-pane fade show active">
                  <div className="notification-card">
                    <h2>Controller of Examinations (CIE/SEE)</h2>
                    <div className="notification-content">
                      <ul>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                                
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>


                      </ul>
                    </div>
                    <button className="btn btn-info btn-sm">Read More</button>
                  </div>
                </div>
              )}

              {activeTab === "aeb" && (
                <div className="tab-pane fade show active">
                  <div className="notification-card">
                    <h2>Academic and Examinations (AEB)</h2>
                    <div className="notification-content">
                      <ul>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                                 
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>
                        <li>
                          <span className="bg-success p-1 rounded">New</span>
                          <Link to="">
                            11/08/2025 | Information | REQUIREMENTS FOR B.E. I
                            YEAR ADMISSION PROCESS TGEAPCET – 2025 (Convener
                            Quota- Final phase)
                          </Link>
                        </li>



                      </ul>
                    </div>
                    <button className="btn btn-info btn-sm">Read More</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllNotifications;
